import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#424949";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    height: 20,
    fontStyle: "bold",
  },
  index: {
    width: "80%",
    textAlign: "center",
    fontSize: 8,
  },
  title: {
    width: "10%",
    height: 20,
    borderRightColor: borderColor,
    borderRightWidth: 0,
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    fontSize: 10,
    padding: 2,
  },
  price: {
    width: "10%",
    height: 20,
    textAlign: "right",
    fontSize: 10,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    padding: 2,
  },
});

const TableRiderTotal = ({ invoice }) => {
  return (
    <>
      {invoice.discount != 0 && invoice.advance != 0 && (
        <View style={styles.row}>
          <Text style={styles.index}>{}</Text>
          <Text style={{ ...styles.title, width: "18%" }}>
            {"Total: "}
            {invoice.items[0]?.currency}
          </Text>
          <Text style={styles.price}>{invoice.total}</Text>
        </View>
      )}

      {invoice.discount > 0 && (
        <View style={styles.row}>
          <Text style={styles.index}>{}</Text>
          <Text style={{ ...styles.title, width: "18%" }}>
            {"Descuento: "}
            {invoice.items[0]?.currency}
          </Text>
          <Text style={styles.price}>{invoice.discount}</Text>
        </View>
      )}

      {invoice.advance > 0 && (
        <View style={styles.row}>
          <Text style={styles.index}>{}</Text>
          <Text style={{ ...styles.title, width: "18%" }}>
            {"Adelando: "}
            {invoice.items[0]?.currency}
          </Text>
          <Text style={styles.price}>{invoice.advance}</Text>
        </View>
      )}

      <View style={styles.row}>
        <Text style={styles.index}>{}</Text>
        <Text style={{ ...styles.title, width: "18%" }}>
          {"Total Pagar: "}
          {invoice.items[0]?.currency}
        </Text>
        <Text style={styles.price}>
          {invoice.total - invoice.discount - invoice.advance}
        </Text>
      </View>
    </>
  );
};

export default TableRiderTotal;
